import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { Card, CardBody } from '../../../../components/card/card';
import {
  GetPayProposal,
  insertPayProposal,
  cleanPayProposalList
} from '../../../../store/HR/Payroll/payProposalSlice';
import { AddPayProposalSchema } from '../../../ValidationForm/validationSchema';
import PayProposalTableList from './PayProposalTableList';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import Loading from '../../../../components/Shared/Loader/Loading';

const AddPayProposal = ({ personData }) => {
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const { t } = useTranslation();
  //___________________________________________________________
  useEffect(() => {
    dispatch(GetPayProposal(personData.assignmentId));

    return () => {
      dispatch(cleanPayProposalList());
    };
  }, [dispatch, personData]);

  const { PayProposalList, loading, error } = useSelector(state => state.PayProposal);
  //_________________________________________________________________

  const formik = useFormik({
    initialValues: {
      changeDate: '',
      proposalReason: '',
      proposedSalaryN: '',
      comments: ''
    },

    validationSchema: AddPayProposalSchema(t),

    onSubmit: values => {
      debugger;
      dispatch(
        insertPayProposal({
          assignmentId: personData.assignmentId,
          changeDate: formik.values.changeDate,
          proposalReason: formik.values.proposalReason,
          proposedSalaryN: parseFloat(formik.values.proposedSalaryN),
          comments: formik.values.comments
        })
      )
        .unwrap()
        .then(() => {
          formik.resetForm();
          CustomAlert({ action: 'Add' });
          // dispatch(cleanPayProposalList());
          dispatch(GetPayProposal(personData.assignmentId));
        })
        .catch(error => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    }
  });

  //______________________________________________

  function handleKeyPress(event) {
    const allowedChars = /^[0-9.]+$/;
    if (!allowedChars.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
      event.preventDefault();
    }
  }

  //____________________________

  return (
    <>
      <Loading loading={loading} error={error}>
        <CardBody>
          <div className='shadow-sm p-2'>
            <Form onSubmit={formik.handleSubmit}>
              <div className='row'>
                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('SalaryValue')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='proposedSalaryN'
                      onChange={formik.handleChange}
                      // onChange={handleInputChange}
                      onKeyPress={handleKeyPress}
                      value={formik.values.proposedSalaryN}
                      isInvalid={formik.touched.proposedSalaryN && formik.errors.proposedSalaryN}
                    />

                    <Form.Control.Feedback type='invalid'>
                      {formik.errors.proposedSalaryN}
                    </Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('ChangeDate')}</label>
                    <Form.Control
                      className='form-control'
                      type='date'
                      name='changeDate'
                      onChange={formik.handleChange}
                      value={formik.values.changeDate}
                      isInvalid={formik.touched.changeDate && formik.errors.changeDate}
                    />
                    <Form.Control.Feedback type='invalid'>
                      {formik.errors.changeDate}
                    </Form.Control.Feedback>
                  </div>
                </div>
                <div className='col-xl-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Reason')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='proposalReason'
                      onChange={formik.handleChange}
                      value={formik.values.proposalReason}
                      isInvalid={formik.touched.proposalReason && formik.errors.proposalReason}
                    />

                    <Form.Control.Feedback type='invalid'>
                      {formik.errors.proposalReason}
                    </Form.Control.Feedback>
                  </div>
                </div>
              </div>

              <div className='row align-items-end'>
                <div className='col-xl-8'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Note')}</label>
                    <Form.Control
                      className='form-control'
                      type='texterea'
                      name='comments'
                      onChange={formik.handleChange}
                      value={formik.values.comments}
                      isInvalid={formik.touched.comments && formik.errors.comments}
                    />
                  </div>
                </div>

                <div className='col-xl-2 text-end  '>
                  <div className=' form-group mb-3 d-flex justify-content-end '>
                    <button
                      disabled={formik.isSubmitting}
                      type='submit'
                      className='btn me-1 btn-theme mb-1 w-100'
                    >
                      {formik.isSubmitting ? (
                        <div className='spinner-border spinner-border-sm me-2'></div>
                      ) : (
                        <i className='fas fa-save fa-lg fa-fw me-2'></i>
                      )}
                      {t('Add')}
                    </button>
                  </div>
                </div>

                <div className='col-xl-2 text-end  '>
                  <div className=' form-group mb-3 d-flex justify-content-end '>
                    <button
                      type='button'
                      className=' btn me-1 btn-default mb-1 w-100'
                      data-bs-dismiss='modal'
                    >
                      <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
          {/* 🟡 4.2 فاصل وعنوان الجدول + جدول العرض */}
          <hr className='mt-4 mb-3' style={{ borderTop: '2px solidrgb(223, 226, 230)' }} />

          <div className='d-flex align-items-center mb-3'>
            <i className='fa fa-money-bill-wave fa-lg text-theme me-2'></i>
            <h5 className='mb-0'>{t('PayProposalHistory')}</h5>
          </div>

          {/* <Card> */}
          <CardBody>
            <PayProposalTableList PayProposalList={PayProposalList} />
          </CardBody>
          {/* </Card> */}
        </CardBody>
      </Loading>
    </>
  );
};

export default AddPayProposal;
